export default {
  transition: {
    error: {
      invalid: {
        en: "Invalid transition for automaton of type: ",
        pt: "Transição inválida para automato do tipo: ",
      },
      example: {
        en: "Transition example: ",
        pt: "Exemplo de transição: ",
      },
      transitionExample: {
        pt: {
          AF: " 'a' ou 'a,b,c' ou 'λ' ",
          AP: " 'a X/Y' ",
          ALL: "'a/a D' ",
          MT: " 'a/a D' ",
        },
        en: {
          AF: " 'a' or 'a,b,c' or 'λ' ",
          AP: " 'a X/Y' ",
          ALL: "'a/a D' ",
          MT: " 'a/a D' ",
        },
      },
    },
    info: {
      automatonDefaultSelection: {
        pt: "Por padrão, o tipo de autômato foi definido como Autômato Finito.",
        en: "By default, the automaton type has been set to Finite Automaton.",
      },
    },
  },
  machineTypes: {
    AF: {
      en: "Finite Automaton",
      pt: "Autômato Finito",
    },
    AP: {
      en: "Pushdown Automaton",
      pt: "Autômato com Pilha",
    },
    ALL: {
      en: "Linearly Bounded Automaton",
      pt: "Autômato Linearmente Limitado",
    },
    MT: {
      en: "Turing Machine",
      pt: "Máquina de Turing",
    },
  },
  invalidFuncionalityForType: {
    en: " is not compatible with the functionality of: ",
    pt: " não é compatível com a funcionalidade de: ",
  },
  automatonSelector: {
    automatonSelection: {
      en: "Select an Automaton",
      pt: "Selecione um Autômato",
    },
  },
};
